module.exports = __webpack_public_path__ + "media/src/assets/images/affinites-a646a675d560dcb3e1d95e3881c87848.jpeg";